!(function () {
  var n, i, o, r, s, a, e;
  ((n = document.querySelector(".burger")),
  (i = document.querySelector(".menu")),
  (o = document.querySelector(".menu__list")),
  (r = document.querySelector(".menu__brand")),
  (s = document.querySelectorAll(".menu__item")),
  (u = document.getElementById("header")),
  (a = !1),
  (e = function () {
    if (a) {
      i.classList.remove("menu--active"),
        o.classList.remove("menu__list--active"),
        r.classList.remove("menu__brand--active"),
        n.classList.remove("burger--close");
      setTimeout(() => {
        u.classList.remove("header-adjustment");
      }, 250);
      for (e = 0, t = s.length; e < t; e++)
        s[e].classList.remove("menu__item--active");
      a = !1;
    } else {
      i.classList.add("menu--active"),
        o.classList.add("menu__list--active"),
        r.classList.add("menu__brand--active"),
        n.classList.add("burger--close");
      u.classList.add("header-adjustment");
      for (var e = 0, t = s.length; e < t; e++)
        s[e].classList.add("menu__item--active");
      a = !0;
    }
  }),
  {
    init: function () {
      n.addEventListener("click", e, !1);
      n.addEventListener(
        "keypress",
        (event) => {
          console.log(event);
          if (event.keyCode === 13) {
            e();
          }
        },
        !1
      );
    },
  }).init();
})();



const researchElement = document.querySelector("#research"),
  deiElement = document.querySelector("#dei"),
  educationElement = document.querySelector("#education"),
  careElement = document.querySelector("#care");

const observerMenu = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // console.log("Element is in view!");
      // console.log("link-" + entry.target.id);

      document
        .getElementById("link-" + entry.target.id)
        .classList.add("ar-nav__link--current");
    } else {
      document
        .getElementById("link-" + entry.target.id)
        .classList.remove("ar-nav__link--current");
    }
  });
});

if (researchElement) {
  observerMenu.observe(researchElement);
  observerMenu.observe(deiElement);
  observerMenu.observe(educationElement);
  observerMenu.observe(careElement);
}

const observerCallout = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    let prompt = entry.target.querySelector(".ar-callout__prompt"),
      fact = entry.target.querySelector(".ar-callout__fact"),
      badge = entry.target.querySelector(".ar-callout__badge");
    if (entry.isIntersecting) {
      // console.log("Callout is in view!");
      // console.log("link-" + entry.target.id);
      // console.log(entry);

      // entry.target.classList.add("ar-nav__link--current");
      // animationStart(entry.target);
      animationStart(prompt);
      animationStart(fact);
      if (badge) {
        animationStart(badge);
      }
    } else {
      document;
      prompt.classList.remove("animating");
      fact.classList.remove("animating");
      if (badge) {
        badge.classList.remove("animating");
      }
    }
  });
});

const callouts = document.querySelectorAll(".ar-callout");
// console.log(callouts);

for (const callout of callouts) {
  observerCallout.observe(callout);
}

// Heading animations

const observerHeading = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      let lines = entry.target.querySelectorAll(".ar-heading-break__line");
      if (entry.isIntersecting) {
        // console.log("Heading is in view!");
        for (const line of lines) {
          animationStart(line);
        }
      } else {
        for (const line of lines) {
          line.classList.remove("animating");
        }
      }
    });
  },
  { threshold: 1 }
);

const headings = document.querySelectorAll(".ar-heading-break");
// console.log(callouts);

for (const heading of headings) {
  observerHeading.observe(heading);
}

// Blockquote symbol animations

const observerBlockquote = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // console.log("Blockquote is in view!");
      animationStart(entry.target);
    } else {
      entry.target.classList.remove("animating");
    }
  });
});

const blockquotes = document.querySelectorAll(
  ".ar-section__figure--blockquote"
);

for (const blockquote of blockquotes) {
  observerBlockquote.observe(blockquote);
}

// Slide overlay animations

const observerSlideOverlay = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // console.log("Slide Overlay is in view!");
      animationStart(entry.target);
    } else {
      entry.target.classList.remove("animating");
    }
  });
});

const slideOverlays = document.querySelectorAll(
  ".ar-section__figure--blockquote"
);

for (const slideOverlay of slideOverlays) {
  observerSlideOverlay.observe(slideOverlay);
}

function animationStart(el) {
  el.classList.remove("animating");
  let elClassList = el.classList.toString();

  console.log(elClassList);

  el.className = elClassList;

  requestAnimationFrame((time) => {
    requestAnimationFrame((time) => {
      el.className = elClassList + " animating";
    });
  });
}

// come back to this if there's time
// if callout is scrolling up then fadeInUp,
// if down, then fadeInDown

// let previousScrollPosition = 0,
//     scrollingDown = 0;

// const isScrollingDown = () => {
//   let goingDown = false;

//   let scrollPosition = window.pageYOffset;

//   if (scrollPosition > previousScrollPosition) {
//     goingDown = true;
//   }

//   previousScrollPosition = scrollPosition;

//   return goingDown;
// };

// const handleScroll = () => {
//   if (isScrollingDown()) {
//     console.log('scrolling down');
//     scrollingDown = 1;
//   } else {
//     console.log('scrolling up');
//     scrollingDown = 0;
//   }
// };

// window.addEventListener("scroll", handleScroll);

// window.onload = (event) => {
//   setTimeout(() => {
//     document.querySelector(".menu__list").style.opacity = 1;
//     document.querySelector(".menu__brand").style.opacity = 1;
//   }, 1000);
// };

// this stops the menu jitter on page load by waiting to apply
// the transition class
window.onload = (event) => {
  setTimeout(() => {
    document.querySelector(".menu__list").classList.add("menu__list--transition");
    document.querySelector(".menu__brand").classList.add("menu__brand--transition");
  }, 1000);
};
